import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'mzic-terms-pt-br',
  imports: [CommonModule],
  templateUrl: './terms-pt-br.component.html',
  styleUrl: './styles.scss',
})
export class TermsPtBrComponent {}
